export default __webpack_public_path__ + "static/media/incoming.1e118414.ogg";